import { Component, OnInit, HostListener, ViewEncapsulation, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class AppComponent implements OnInit {
  title = 'EWS Platform';
  isScrolled = signal(false);
  showLoading = true;

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  get routeHasHome(): boolean {
    return this.router.url.includes('home');
  }

  ngOnInit() {
    // Sync user from sessionStorage so all components get current user (e.g. after refresh or new tab)
    this.auth.refreshUser();
    setTimeout(() => {
      this.showLoading = false;
    }, 1000);
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.isScrolled.set(window.scrollY > 50);
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
